import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MuiToolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import Grid from "@material-ui/core/Grid";

const Toolbar = ({classes, children, disableGutters, title, subtitle, orientation, items}) => (
    <MuiToolbar disableGutters={disableGutters}>
        <Typography
            variant="h2"
            className={classes.tabBarTitle}
        >
            {title}
        </Typography>

        <Typography variant="subtitle2">
            {subtitle}
        </Typography>

        {/* Insert children here */}
        {children}

        <Grid container spacing={8}
              direction="column"
              justify="flex-end"
              alignItems="flex-end"
              style={{width:'50%'}}
        >
        {/* Build buttons from list */}
        {items.map((item, idx) => (
            <Grid item xs={12} key={item.href || `toolbar_item_${idx}`}>
                <Button
                    component="a"
                    variant={item.variant || 'contained'}
                    color={item.color || 'primary'}
                    type={item.type}
                    href={item.href}
                    onClick={item.onClick}
                    className={classes.tabBarButton}
                    size={item.size || 'medium'}
                >
                    <Icon className={classes.tabBarButtonIcon}>
                        {item.icon}
                    </Icon>
                    {item.text}
                </Button>
            </Grid>
        ))}
        </Grid>
    </MuiToolbar>
);

Toolbar.propTypes = {
    disableGutters: PropTypes.bool,
    title: PropTypes.any.isRequired,
    subtitle: PropTypes.any,
    items: PropTypes.array,
};

Toolbar.defaultProps = {
    items: [],
};

const styles = theme => ({
    tabBar: {
        marginBottom: theme.spacing.unit * 3,
    },
    tabBarTitle: {
        flexGrow: 1,
        verticalAlign:'top',
    },
    tabBarButton: {
        marginLeft: theme.spacing.unit * 2,
    },
    tabBarButtonIcon: {
        marginRight: theme.spacing.unit,
    },
});

export default withStyles(styles)(Toolbar);
